import * as $ from 'jquery'

window.jQuery = window.$ = $

//CARREGAMOS O JQUERY DESSA FORMA PARA QUE O SIFRÃO SEJA UTILIZADO NO JQUERY COMO SELETOR NA NOSSA APLICAÇÃO